import { authenticatedApiClient } from "./interceptors/authInterceptor";
import { baseFetch } from "./baseFetch";

// Реэкспортируем типы для удобства
export type { ApiError, BaseFetchOptions } from "./baseFetch";
export { ApiClientError } from "./baseFetch";

/**
 * Расширенные опции для apiClient
 */
interface ApiRequestOptions extends RequestInit {
  params?: Record<string, string>;
  requiresAuth?: boolean;
  suppressErrorToast?: boolean;
}

/**
 * Главный API клиент приложения
 * Автоматически обрабатывает авторизацию при requiresAuth: true
 */
export async function apiClient<T>(
  endpoint: string,
  options: ApiRequestOptions = {},
): Promise<T> {
  const { requiresAuth = false, ...restOptions } = options;

  // Если запрос требует авторизации, используем authenticatedApiClient
  if (requiresAuth) {
    return authenticatedApiClient<T>(endpoint, restOptions);
  }

  // Иначе делаем обычный запрос
  return baseFetch<T>(endpoint, restOptions);
}
